import { __module as u } from "./ghl-ui.es1744.js";
(function(v, a) {
  Object.defineProperty(a, "__esModule", {
    value: !0
  }), a.default = o;
  function o(e) {
    return function(l) {
      var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, c = l.match(e.matchPattern);
      if (!c)
        return null;
      var i = c[0], r = l.match(e.parsePattern);
      if (!r)
        return null;
      var t = e.valueCallback ? e.valueCallback(r[0]) : r[0];
      t = n.valueCallback ? n.valueCallback(t) : t;
      var d = l.slice(i.length);
      return {
        value: t,
        rest: d
      };
    };
  }
  v.exports = a.default;
})(u, u.exports);
var s = u.exports;
export {
  s as b
};
